import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/level_1.png'
import _imports_1 from '../assets/images/level_5.jpeg'


const _hoisted_1 = { id: "main-page" }
const _hoisted_2 = { class: "main-root" }
const _hoisted_3 = {
  id: "scroll-main-describe",
  class: "main-root__item level_2"
}
const _hoisted_4 = {
  id: "scroll-master-class",
  class: "main-root__item level_3"
}
const _hoisted_5 = { class: "main-root__item level_4" }
const _hoisted_6 = { class: "main-root__item level_4" }
const _hoisted_7 = { class: "main-root__item level_6" }
const _hoisted_8 = { class: "main-root__item level_7" }
const _hoisted_9 = {
  id: "scroll-student-works",
  class: "main-root__item level_8"
}
const _hoisted_10 = { class: "main-root__item level_9" }
const _hoisted_11 = {
  id: "scroll-address",
  class: "main-root__item level_10"
}
const _hoisted_12 = { class: "main-root__item contact_info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_comp = _resolveComponent("header-comp")!
  const _component_main_sing_up = _resolveComponent("main-sing-up")!
  const _component_sing_up_subscription = _resolveComponent("sing-up-subscription")!
  const _component_sing_up_offers = _resolveComponent("sing-up-offers")!
  const _component_sing_up_certificate = _resolveComponent("sing-up-certificate")!
  const _component_main_describe = _resolveComponent("main-describe")!
  const _component_master_class = _resolveComponent("master-class")!
  const _component_subscriptions = _resolveComponent("subscriptions")!
  const _component_courses = _resolveComponent("courses")!
  const _component_certificates = _resolveComponent("certificates")!
  const _component_offers = _resolveComponent("offers")!
  const _component_student_works = _resolveComponent("student-works")!
  const _component_teacher_works = _resolveComponent("teacher-works")!
  const _component_address_info = _resolveComponent("address-info")!
  const _component_contact_info = _resolveComponent("contact-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_comp, { onNavClick: _ctx.onNavClick }, null, 8, ["onNavClick"]),
    (_ctx.signMain)
      ? (_openBlock(), _createBlock(_component_main_sing_up, {
          key: 0,
          onSignClose: _cache[0] || (_cache[0] = ($event: any) => {_ctx.signMain = false; _ctx.signMainData.title = ''}),
          title: _ctx.signMainData.title
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.signUpSubscription.show)
      ? (_openBlock(), _createBlock(_component_sing_up_subscription, {
          key: 1,
          "sub-type": _ctx.signUpSubscription.subType,
          onSignClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signUpSubscription.show = false))
        }, null, 8, ["sub-type"]))
      : _createCommentVNode("", true),
    (_ctx.signUpOffers.show)
      ? (_openBlock(), _createBlock(_component_sing_up_offers, {
          key: 2,
          offType: _ctx.signUpOffers.offType,
          onSignClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signUpOffers.show = false))
        }, null, 8, ["offType"]))
      : _createCommentVNode("", true),
    (_ctx.signUpCertificate.show)
      ? (_openBlock(), _createBlock(_component_sing_up_certificate, {
          key: 3,
          "cert-type": _ctx.signUpCertificate.certType,
          onSignClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signUpCertificate.show = false))
        }, null, 8, ["cert-type"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "main-root__item level_1" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_main_describe)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_master_class, {
          onPurchase: _cache[4] || (_cache[4] = (title) => {_ctx.signMainData.title = title; _ctx.signMain = true})
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_subscriptions, {
          onPurchase: _cache[5] || (_cache[5] = (subType) => {_ctx.signUpSubscription.subType = subType; _ctx.signUpSubscription.show = true})
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_courses, {
          onPurchase: _cache[6] || (_cache[6] = (title) => {_ctx.signMainData.title = title; _ctx.signMain = true})
        })
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "main-root__item level_5" }, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_certificates, {
          onPurchase: _cache[7] || (_cache[7] = (certType) => {_ctx.signUpCertificate.certType = certType; _ctx.signUpCertificate.show = true})
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_offers, {
          onPurchase: _cache[8] || (_cache[8] = (offType) => {_ctx.signUpOffers.offType = offType; _ctx.signUpOffers.show = true})
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_student_works)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_teacher_works)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_address_info)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_contact_info)
      ])
    ])
  ]))
}